import { atom } from "recoil";

import { getAccessToken } from "@ryde/shared";

import { LandingStepEnum } from "../enums";
import {
  ILandingActiveStepError,
  ILandingDropdownItemStations,
  ILandingInfoPanelContent,
  ILandingInitData,
  ILandingMessagesDto,
  ILandingProfileDto,
  LandingSettingsDto,
} from "../models";

export const landingActiveStepAtom = atom<LandingStepEnum>({
  key: "landingActiveStepAtom",
  default: LandingStepEnum.LoginStep,
});

export const landingActiveStepErrorsAtom = atom<ILandingActiveStepError | null>(
  {
    key: "landingActiveStepErrorsAtom",
    default: null,
  },
);

export const landingSettingsLandingsDtoAtom = atom<
  LandingSettingsDto | undefined
>({
  key: "landingSettingsLandingsDtoAtom",
  default: undefined,
});

export const profileLandingDtoAtom = atom<ILandingProfileDto | undefined>({
  key: "profileLandingDtoAtom",
  default: undefined,
});

export const isLoggedInLandingAtom = atom<boolean>({
  key: "isLoggedInLandingAtom",
  default: Boolean(getAccessToken()),
});

export const isLoginLandingInProgressAtom = atom<boolean>({
  key: "isLoginLandingInProgressAtom",
  default: false,
});

export const loginLandingErrorsAtom = atom<string[] | undefined>({
  key: "loginLandingErrorsAtom",
  default: undefined,
});

export const landingMessagesAtom = atom<ILandingMessagesDto | undefined>({
  key: "landingMessagesAtom",
  default: undefined,
});

export const landingInfoPanelAtom = atom<ILandingInfoPanelContent | undefined>({
  key: "landingInfoPanelAtom",
  default: undefined,
});

export const landingInitDataAtom = atom<ILandingInitData | undefined>({
  key: "landingInitDataAtom",
  default: undefined,
});

export const landingDropdownStationListAtom = atom<
  ILandingDropdownItemStations[] | undefined
>({
  key: "landingDropdownStationListAtom",
  default: [],
});
